<template>
  <b-container>
    <Breadcrumbs crumbString="Creative Services,Graphic Design"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS graphic designers specialize in interpretive communication.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img graphic-design-75-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design03.jpg') + ')'}"></div>
                  <div class="img graphic-design-57-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design04.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-12 col-md-5">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img graphic-design-87-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design05.jpg') + ')'}"></div>
                  <div class="img graphic-design-111-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design06.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img graphic-design-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design02.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img graphic-design-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-design/interpretive-graphic-design01.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Graphic Design'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/creativeServices/GraphicDesign.vue